import timeSince from './timeSince.js';

function normalizeMs(raw) {
  if (raw == null || raw === '') return 0;
  if (typeof raw === 'number' && Number.isFinite(raw) && raw > 0) {
    return raw < 1e12 ? raw * 1000 : raw;
  }
  const asText = String(raw).trim();
  if (asText && !asText.includes('-') && !asText.includes('T')) {
    const asNumber = Number(asText);
    if (Number.isFinite(asNumber) && asNumber > 0) {
      return asNumber < 1e12 ? asNumber * 1000 : asNumber;
    }
  }
  const parsed = Date.parse(asText);
  return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Zeitpunkt der letzten Geräteaktivität:
 * MDM-Check-in (Webhook) oder DDM-Statusreport — je nachdem, was neuer ist.
 * updatedAt nur Fallback für ältere Datensätze.
 */
export function deviceLastSeenMs(device) {
  const mdm = normalizeMs(device?.lastCheckedIn);
  const ddm = normalizeMs(device?.lastDdmStatusReportAt);
  const newest = Math.max(mdm, ddm);
  if (newest > 0) return newest;
  return normalizeMs(device?.updatedAt);
}

export function deviceLastSeenLabel(device) {
  const ms = deviceLastSeenMs(device);
  return ms ? timeSince(ms) : '—';
}

export function deviceMdmCheckinMs(device) {
  return normalizeMs(device?.lastCheckedIn);
}

export function deviceDdmReportMs(device) {
  return normalizeMs(device?.lastDdmStatusReportAt);
}

export function deviceDdmReportLabel(device) {
  const ms = deviceDdmReportMs(device);
  return ms ? timeSince(ms) : '—';
}
